import { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import useRefresh from "../hooks/useRefresh";

const PersistLogin = () => {
  const [isLoading, setIsLoading] = useState(true);

  const { auth } = useAuth();
  const refresh = useRefresh();

  useEffect(() => {
    const verifyToken = async () => {
      try {
        await refresh();
      } catch (err) {
        console.log(err);
      } finally {
        setIsLoading(false);
      }
    };
    !auth?.accessToken ? verifyToken() : setIsLoading(false);
  }, []);

  return <>{isLoading ? <p>isLoading</p> : <Outlet />}</>;
};

export default PersistLogin;
